import { lazy } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const Enem365LoginPage = lazy(() => import('../pages/LoginPage'));
const Enem365RecoverAccountPage = lazy(() => import('../pages/RecoverAccount'));
const Enem365HomePage = lazy(() => import('../pages/Home'));
const Enem365SisuPage = lazy(() => import('../pages/Sisu'));
const Enem365ExamPage = lazy(() => import('../pages/Exam'));
const Enem365FeedbackPage = lazy(() => import('../pages/Feedback'));

/*
 * O produto saiu de /enem-365 para /simulado-enem. Links antigos (inclusive o do
 * e-mail de confirmacao da inscricao) continuam chegando no lugar certo.
 */
export function LegacyEnem365Redirect() {
  const { pathname, search, hash } = useLocation();

  return (
    <Navigate
      to={`${pathname.replace(/^\/enem-365/, '/simulado-enem')}${search}${hash}`}
      replace
    />
  );
}

export const Enem365Routes = [
  {
    path: '/simulado-enem/login',
    element: <Enem365LoginPage />,
  },
  {
    path: '/simulado-enem/recuperar-conta',
    element: <Enem365RecoverAccountPage />,
  },
  {
    path: '/simulado-enem',
    element: <Enem365HomePage />,
  },
  {
    path: '/simulado-enem/sisu',
    element: <Enem365SisuPage />,
  },
  {
    path: '/simulado-enem/prova/:day',
    element: <Enem365ExamPage />,
  },
  {
    path: '/simulado-enem/gabarito/:day',
    element: <Enem365FeedbackPage />,
  },
];
